<template>
  <div>
    <el-form status-icon ref="" label-width="100px" class="demo-ruleForm">
      <el-form-item label="标题">
        <el-input v-model="title"></el-input>
      </el-form-item>
      <el-upload class="upload-demo" action="#" name="file" :http-request="requestUpload"
        :before-upload="beforeAvatarUpload" :on-success="handleSuccess" multiple />
      <el-form-item label="内容" class="editor">
        <quill-editor ref="myQuillEditor" v-model="content" class="myQuillEditor" :options="editorOption" />
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="TechClassID" placeholder="技术类型">
          <el-option v-for="item in techClassList" :key="item.id" :label="item.name" :value="item.id"
            :disabled="item.disabled" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="ex-btn" @click="submit()">马上发表</el-button>
        <router-link :to="{ name: 'articlelist' }" class="left">
          返回列表
        </router-link>
      </el-form-item>
    </el-form>
  </div>
</template>

<style>
.editor>div {
  height: 500px;
}

.myQuillEditor {
  height: 400px;
  background-color: white;
}
</style>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import TechClassApi from '../api/TechClassApi'
import hljs from 'highlight.js'
import 'highlight.js/styles/monokai-sublime.css'

export default {
  components: {
    quillEditor,
  },
  props: {
    value: {
      type: String,
    },
    toref: {
      type: String,
      default: "quillEditor",
    },
    quillIndex: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    value: function () {
      this.content = this.value;
    },
  },
  data() {
    return {
      TechClassID: 0,
      techClassList: [],
      quillIndex1: 1,
      title: "",
      content: "",
      id: 0, //文章ID，如果为0则是新增文章
      Article: null,
      editorOption: {
        theme: "snow",
        placeholder: "请输入文章内容...",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
              ["blockquote", "code-block"], //引用，代码块
              [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
              [{ list: "ordered" }, { list: "bullet" }], //列表
              [{ script: "sub" }, { script: "super" }], // 上下标
              [{ indent: "-1" }, { indent: "+1" }], // 缩进
              [{ direction: "rtl" }], // 文本方向
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              [{ font: [] }], //字体
              [{ align: [] }], //对齐方式
              ["clean"], //清除字体样式
              ["image", "video"], //上传图片、上传视频
            ],
            handlers: {
              image: (value) => {
                if (value) {
                  const index = 0; //this.quillIndex;
                  document
                    .querySelectorAll(".upload-demo input")[index].click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
          // 语法高亮
          syntax: {
            highlight: text => {
              var contHtml = hljs.highlightAuto(text).value;
              if (contHtml != null && contHtml != "" && contHtml.length > 3) {
                //this.content=contHtml;有bug
                this.$emit('childQuill', contHtml);
              }
              //this.content=contHtml会被触发两次
              return contHtml;
            }
          }
        },
      },
    };
  },
  mounted() {
    this.getArticle();

  },
  methods: {
    getTechClassList() {
      TechClassApi.getTechClassList().then(res => {
        this.techClassList = res.data;
        this.TechClassID = this.Article.techClassID;
      });
    },
    getArticle() {
      this.id = this.$route.query.id;
      if (this.id > 0) {
        this.$http
          .get("/api/article2/" + this.id)
          .then((r) => {
            if (r.data != null) {
              var article = r.data;
              this.Article = article;
              this.title = article.title;
              this.content = article.content;
              this.getTechClassList();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.id = 0;//重置为0，不然就是空值，空值后台会报错
      }
    },
    submit() {
      var qs = require("querystring");
      let quill = this.$refs.myQuillEditor.quill;
      this.content = quill.root.innerHTML
      var data = {
        id: this.id,
        title: this.title,
        content: this.content,
        techClassID: this.TechClassID,
      };
      this.$http
        .post("/api/article/", qs.stringify(data))
        .then((res) => {
          if (res != "1") {
            var tips = "发表成功";
            if (this.id > 0) {
              tips = "编辑成功";
            } else {
              this.title = "";
              this.content = "";
            }
            this.$message.info(tips);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.info("发表失败，请重试");
        });
      console.log(this.content);
    },
    //覆盖默认的上传行为
    requestUpload(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      this.$http
        .post("/api/image/", formData)
        .then((res) => {
          params.onSuccess(res);
          //this.msgSuccess("上传成功");
          this.$message.info("上传图片图片成功");
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("上传图片图片失败");
        });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg " || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG , PNG格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleSuccess(res) {
      //alert(JSON.stringify(res));
      //获取富文本组件实例
      // let quill = this.$refs.myTextEditor.quill;
      //如果上传成功
      if (res) {
        //动态添加 ref  通过 eval () 去执行
        //let toeval = "this.$refs." + this.toref + ".quill";
        //eval() 函数可计算某个字符串，并执行其中的的 JavaScript 代码。
        //let quill = eval(toeval);
        let quill = this.$refs.myQuillEditor.quill;
        console.log(quill);
        //获取光标所在位置
        let length = quill.selection.savedRange.index;
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(
          length,
          "image",
          process.env.VUE_APP_IMAGE_URL + res.data.replace(".", "-s.")
        );
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        // 提示信息，需引入Message
        this.$message.error("图片插入失败");
      }
      //this.form.unscramble = res.fileName;
    },
  },
};
</script>
